import { ca } from '@cian/analytics';
import { getProductsData } from '../../../shared/selectors/analytics';
import { TExtra } from '../../../shared/types/analytics/products';
import { EPromoType } from '../../../shared/types/newbuilding/promos';

interface ITrackPromotion {
  newbuildingId: number;
  promoId: number;
  promoType: EPromoType;
}

interface ITrackPhoneExpand extends ITrackPromotion {
  gaLabel: string;
}

export function trackPhoneExpand({ newbuildingId, gaLabel, promoType, promoId }: ITrackPhoneExpand) {
  const extra: TExtra = {
    label: promoType,
    promotion_id: promoId,
  };

  ca('eventSite', {
    action: 'Open_jk_promotions',
    category: 'Phones',
    label: gaLabel,
    name: 'oldevent',
    products: [getProductsData(newbuildingId, null, extra)],
  });
}

export function trackMortgageClick({ newbuildingId, promoId, promoType }: ITrackPromotion) {
  ca('eventSite', {
    action: 'click_morgage',
    category: 'PromotionsJK',
    label: promoType,
    name: 'oldevent',
    products: [getProductsData(newbuildingId, null, { promoId })],
  });
}

interface ITrackAvailableJkClick extends ITrackPromotion {
  position: number;
}

export function trackAvailableJkClick({ newbuildingId, promoId, promoType, position }: ITrackAvailableJkClick) {
  ca('eventSite', {
    action: 'click_jk',
    category: 'PromotionsJK',
    label: promoType,
    name: 'oldevent',
    products: [getProductsData(newbuildingId, null, { promoId }, position)],
  });
}
